/**************************************************
 * Nombre:       Formulario_Soporte_Ver
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import IngresoTexto from "../../Modulo_formularios/Componentes/IngresoTexto";
import {FlagOutlined, NumbersOutlined, Title} from "@mui/icons-material";
import {useEffect, useState} from "react";
import Zoom from 'react-medium-image-zoom'
import 'react-medium-image-zoom/dist/styles.css'
import IngresoFecha from "../../Modulo_formularios/Componentes/IngresoFecha";

const Formulario_Soporte_Ver = ({...props}) => {
    const [img, setImg] = useState('');

    useEffect(() => {

        let img = props.props.getValues('img')
        if (img) {
            setImg(img);
        }


    }, [props.props.watch('img')]);
    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >


                <Grid container size={6}>
                    <IngresoTexto Icono={NumbersOutlined} nombre={'Numero'} dato={'consecutivo'} {...props}
                                  editable={false}
                    />
                </Grid>

                <Grid container size={6}>
                    <IngresoTexto Icono={FlagOutlined} nombre={'Estado'} dato={'estado'} {...props}
                                  editable={false}
                    />
                </Grid>


                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto Icono={Title} nombre={'Asunto'} dato={'asunto'} {...props}
                                  editable={false}
                    />
                </Grid>


                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto lineas={6} nombre={'Descripcion del asunto'} dato={'descripcion'} {...props}
                                  editable={false}
                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', px: 0.5}}>
                    <Typography>Respuesta</Typography>
                </Grid>

                <Grid container size={6}>
                    <IngresoFecha nombre={'Fecha de respuesta'} dato={'fechaRespuesta'} {...props}
                                  editable={false}
                    />
                </Grid>

                <Grid container size={6}>

                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto lineas={8} nombre={'Respuesta'} dato={'respuesta'} {...props}
                                  editable={false}
                    />
                </Grid>


                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', px: 0.5}}>
                    <Typography>Imagen o captura de pantalla</Typography>
                </Grid>

                {img &&

                    <Grid container size={{xs: 12, sm: 12, md: 6}} sx={{justifyContent: 'center'}}>
                        <Zoom>
                            <img src={img} width={'100%'} height={'auto'}/>
                        </Zoom>
                    </Grid>

                }


            </Grid>

        </form>

    )

}
export default Formulario_Soporte_Ver